// extracted by mini-css-extract-plugin
export var name = "Post-module--name--+aqvT";
export var role = "Post-module--role--kIRIT";